import { noop } from '../../../utils/index.js';

const INITIAL_MESSAGE_METHODS = {
    clear: noop,
    custom: noop,
    error: noop,
    info: noop,
    success: noop,
    warning: noop,
};
const INITIAL_MESSAGE_CONTEXT_VALUE = Object.assign({ compact: INITIAL_MESSAGE_METHODS, default: INITIAL_MESSAGE_METHODS }, INITIAL_MESSAGE_METHODS);
const AUTO_HIDE_DURATION_DEFAULT = 2000;
const MESSAGE_POSITION_DEFAULT = 'top-right';
const TOAST_VARIANT_DEFAULT = 'neutral';
const TOAST_TYPE_COMPACT = 'compact';
const TOAST_TYPE_DEFAULT = 'default';

export { AUTO_HIDE_DURATION_DEFAULT, INITIAL_MESSAGE_CONTEXT_VALUE, MESSAGE_POSITION_DEFAULT, TOAST_TYPE_COMPACT, TOAST_TYPE_DEFAULT, TOAST_VARIANT_DEFAULT };
